<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title"><i class="el-icon-bell"></i> 通知中心</h1>
            <p class="page-subtitle">注册 / 表单 / 下单 / 支付 / 改价 / 流转事件提醒</p>
          </div>
        </div>

        <div class="action-card">
          <div class="action-buttons">
            <el-badge :value="unreadCount > 99 ? '99+' : unreadCount" :hidden="!unreadCount" class="unread-badge">
              <el-button size="mini" icon="el-icon-check">未读 {{ unreadCount }}</el-button>
            </el-badge>
            <el-button type="primary" size="mini" icon="el-icon-finished" @click="markAllRead" :disabled="!unreadCount">全部标已读</el-button>
            <el-button size="mini" icon="el-icon-refresh" @click="getList">刷新</el-button>
          </div>
        </div>

        <div class="search-card">
          <div class="search-content">
            <el-form size="mini" :inline="true">
              <el-form-item>
                <el-select v-model="searchCondition.notify_type" placeholder="通知类型" clearable style="width:170px">
                  <el-option v-for="t in typeOptions" :key="t.value" :label="t.label" :value="t.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="searchCondition.is_read" placeholder="阅读状态" clearable style="width:130px">
                  <el-option label="未读" value="0"></el-option>
                  <el-option label="已读" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="mini" icon="el-icon-search" @click="searchButton">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div class="table-card">
          <el-table :data="dataList" v-loading="loading" style="width:100%">
            <el-table-column width="60" label="状态" align="center">
              <template slot-scope="s">
                <el-tag v-if="s.row.is_read === '1'" size="mini" type="info">已读</el-tag>
                <el-tag v-else size="mini" type="danger">未读</el-tag>
              </template>
            </el-table-column>
            <el-table-column width="130" label="类型" align="center">
              <template slot-scope="s">
                <el-tag size="mini" :type="typeTag(s.row.notify_type)">{{ typeLabel(s.row.notify_type) }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="内容" min-width="320">
              <template slot-scope="s">
                <div :class="{ 'unread-title': s.row.is_read !== '1' }" style="font-weight:600">{{ s.row.title }}</div>
                <div style="color:#666;font-size:13px">{{ s.row.content }}</div>
              </template>
            </el-table-column>
            <el-table-column width="180" label="关联" align="center">
              <template slot-scope="s">
                <span v-if="s.row.ref_no" style="font-family:monospace">{{ s.row.ref_no }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column width="160" label="时间" align="center">
              <template slot-scope="s">{{ formatTime(s.row.notify_time) }}</template>
            </el-table-column>
            <el-table-column width="120" label="操作" align="center">
              <template slot-scope="s">
                <el-button v-if="s.row.is_read !== '1'" size="mini" type="primary" plain @click="markRead([s.row.id])">标已读</el-button>
                <el-button v-else size="mini" type="info" plain disabled>已读</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style="margin-top:14px;text-align:right" background layout="total, prev, pager, next"
            :total="total" :current-page.sync="searchCondition.page" :page-size="searchCondition.page_size"
            @current-change="getList"></el-pagination>
        </div>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'

export default {
  name: 'notification-list',
  components: { PageHeaderLayout },
  data() {
    return {
      loading: false,
      dataList: [],
      total: 0,
      unreadCount: 0,
      searchCondition: { notify_type: '', is_read: '', page: 1, page_size: 15 },
      typeOptions: [
        { value: 'register', label: '注册' },
        { value: 'survey', label: '表单' },
        { value: 'inquiry', label: '咨询' },
        { value: 'order_created', label: '下单' },
        { value: 'order_paid', label: '已付款' },
        { value: 'price_changed', label: '改价' },
        { value: 'status_updated', label: '流转更新' },
        { value: 'chat_transfer', label: '客服转人工' },
        { value: 'chat_lead', label: '客服线索' }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    typeLabel(v) {
      const f = this.typeOptions.find((t) => t.value === v)
      return f ? f.label : v
    },
    typeTag(v) {
      const map = { register: '', survey: 'success', inquiry: 'warning', order_created: 'primary', order_paid: 'success', price_changed: 'danger', status_updated: 'info', chat_transfer: 'danger', chat_lead: 'warning' }
      return map[v] || 'info'
    },
    formatTime(t) {
      if (!t) return '-'
      const d = new Date(t)
      if (isNaN(d.getTime())) return String(t)
      const p = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    },
    searchButton() {
      this.searchCondition.page = 1
      this.getList()
    },
    async getList() {
      this.loading = true
      try {
        const res = await this.$api.post('/service/notification/list', this.searchCondition)
        if (this.$apiSuccess(res)) {
          const d = res.data || {}
          this.dataList = d.list || []
          this.total = Number((d.page && d.page.total) || 0)
          this.unreadCount = Number(d.unread_count || 0)
        } else {
          this.$message.error(res.message || '加载失败')
        }
      } catch (e) {
        this.$message.error((e && e.message) || '加载失败')
      } finally {
        this.loading = false
      }
    },
    async markRead(ids) {
      try {
        const res = await this.$api.post('/service/notification/mark_read', { ids: ids || [] })
        if (this.$apiSuccess(res)) {
          await this.getList()
        } else {
          this.$message.error(res.message || '操作失败')
        }
      } catch (e) {
        this.$message.error((e && e.message) || '操作失败')
      }
    },
    async markAllRead() {
      await this.markRead([])
    }
  }
}
</script>

<style lang="stylus" scoped>
.unread-title
  color #303133
.unread-title::before
  content ''
  display inline-block
  width 6px
  height 6px
  border-radius 50%
  background #f56c6c
  margin-right 6px
  vertical-align middle
.unread-badge
  margin-right 12px
</style>
